import { render, staticRenderFns } from "./Regexes.vue?vue&type=template&id=8f247a96&"
import script from "./Regexes.vue?vue&type=script&lang=ts&"
export * from "./Regexes.vue?vue&type=script&lang=ts&"
import style0 from "./Regexes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports